module.exports = __webpack_public_path__ + "img/empty-5.ce377829.svg";